import AutorenewIcon from "@mui/icons-material/Autorenew";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { useTranslation } from "react-i18next";
import Chip from "./Chip";
import styles from "./m3.module.css";

const FALLBACK_STATUS = { tone: "neutral", Icon: RadioButtonUncheckedIcon };

// Status keyword (lower case) → chip tone and icon.
const STATUS_MAP = {
  validated: { tone: "success", Icon: CheckCircleOutlineIcon },
  approved: { tone: "success", Icon: CheckCircleOutlineIcon },
  completed: { tone: "success", Icon: CheckCircleOutlineIcon },
  published: { tone: "primary", Icon: CheckCircleOutlineIcon },
  pending: { tone: "warning", Icon: ScheduleIcon },
  "in progress": { tone: "info", Icon: AutorenewIcon, spin: true },
  processing: { tone: "info", Icon: AutorenewIcon, spin: true },
  rejected: { tone: "error", Icon: CancelOutlinedIcon },
  failed: { tone: "error", Icon: ErrorOutlineIcon },
  "not validated": FALLBACK_STATUS,
  draft: FALLBACK_STATUS,
};

/**
 * Status chip for workflow states (validation, processing, publishing).
 * Unknown statuses render as a neutral chip with the status text.
 *
 * @param {string} status - e.g. "Validated", "Pending", "Not Validated", "Rejected", "In Progress"
 * @param {string} emptyLabel - text shown when status is empty
 * @param {string} tooltip
 */
const StatusChip = ({ status, emptyLabel = "Not Validated", tooltip }) => {
  const { t } = useTranslation();
  const label = status || emptyLabel;
  const key = String(label).trim().toLowerCase().replace(/[-_]/g, " ");
  const { tone, Icon, spin } = STATUS_MAP[key] || FALLBACK_STATUS;
  return (
    <Chip tone={tone} size="sm" icon={<Icon className={spin ? styles.spin : undefined} />} tooltip={tooltip}>
      {t(label)}
    </Chip>
  );
};

export default StatusChip;
